import { Provider } from '@angular/core';
import { HTTP_ERROR_HANDLERS } from '../tokens/http-error-handlers';
import { HttpErrorHandlerFn } from '../errors/handlers/http-error-handler-fn';

export const provideHttpErrorHandlers = (
  handlers: HttpErrorHandlerFn[],
): Provider => {
  return {
    provide: HTTP_ERROR_HANDLERS,
    useFactory: () => [...handlers],
  };
};
